//服务对象状态
var elderly={
  //婚姻状况
  maritalValue:slectValue(['未婚','已婚','离异','丧偶','再婚']),
  //政治面貌
  politicalOutlook:slectValue(['中共党员','中共预备党员','共青团员','民革党员','民盟盟员','民建会员','民进会员','农工党党员','致公党党员','九三学社社员','台盟盟员','无党派民主人士','群众']),
  //文化程度
  education:slectValue(['文盲','小学','初中','高中','中专','大专','本科','研究生']),
  //户籍性质
  natureHRegistrater:slectValue(['城市','农村']),
  //服务类型
  serviceType:slectValue(['政府购买','有偿服务']),
  //服务状态
  serviceStatus:slectValue(['正常服务','停止服务','去世','迁出服务区']),
  //关系
  relationship:slectValue(['祖孙','父子','母子','父女','母女','姐弟','姐妹','兄弟','兄妹','姑侄','叔侄','舅甥','姨甥','婆媳','女婿','夫妻','其他']),
  //自理能力
  selfCareAbility:slectValue(['完全自理','半自理','完全不能自理']),
  //心理状况
  mentalState:slectValue(['正常','偶尔有孤独感','经常觉得有孤独感']),
  //居住情况
  livingConditions:slectValue(['独自居住','与老伴居住','与子女合住','自费入住养老机构','免费入住养老机构']),
  //血型
  bloodType:slectValue(['A型','B型','AB型','O型','其他']),
  //残疾状况
  disabilityType:slectValue(['无','视力残疾','听力残疾','肢体残疾','智力残疾','精神残疾','其他残疾']),
  //吸烟状况
  smokeType:slectValue(['从不吸烟','偶尔吸烟','经常吸烟','已戒烟']),
  //饮酒频率
  drinkType:slectValue(['从不饮酒','偶尔饮酒','经常饮酒','每天饮酒','已戒酒']),
  //锻炼频率
  exercise:slectValue(['偶尔','经常','每天']),
  //是否
  status:slectValue(['是','否']),
  //每次锻炼时间
  exerciseTime:slectValue(['半小时','1小时','2小时']),
  //经济来源
  economicSources:slectValue(['城市低保金','五保金','子女供养','家庭存款','离退休金','抚恤金','商业保险','其他']),
  //饮食习惯
  dietHabits:slectValue(['荤素均衡','荤食为主','素食为主','嗜盐','嗜油','嗜糖']),
  //补助类别
  subsidy:slectValue(['无','低保对象','特困对象','扶贫对象']),
  //残疾等级
  disabilityLevel:slectValue(['一级','二级','三级','四级']),
  //老人分类
  elderlyClass:slectValue(['一般助餐补助老人','70岁以上低保老人','70岁以上空巢老人','90岁以上高龄老人']),
  //子女状况
  children:slectValue(['无子女','子女死亡','1个子女','2个子女','3个子女','4个子女','5个子女','6个子女','7个子女','8个子女','9个子女','10个子女']),
  //医疗保障情况
  medicalSecurity:slectValue(['城镇职工医疗保险','城镇居民医疗保险','新型农村合作医疗','商业保险','其他','无']),
  //服务需求
  serviceDemand:slectValue(['保洁','钟点工','陪护','定点用餐','送餐','助浴','理发','清洗油烟机','清洗燃气灶','代办代购服务','紧急救援','基本健康监护','推拿按摩','读报','陪聊','陪同服务','燃气灶维修','修锁换锁','门窗维修','空调维修','旅游服务','农产品代购']),
  //兴趣爱好,
  likeValue:slectValue(['散步','跑步','竞走','油画','书法','国画','剪纸','种花','钓鱼','收藏','集邮','冬泳','登山','魔术','古玩','养宠物','时装表演','骑车','养鱼'	,'烹饪'	,'唱歌'	,'跳舞'	,'民族舞'	,'广场舞',	'街舞',	'现代舞'	,'五子棋',	'国标舞',	'交谊舞'				
  ,'口琴'	,'古筝',	'琵琶',	'钢琴',	'笛子',	'架子鼓',	'萨克斯',	'唢呐',	'抖空竹',	'大提琴',	'二胡','小提琴'	,'手风琴'	,'腰鼓',	'吉他'
  ,'黄梅戏',	'川剧',	'豫剧',	'秦腔',	'评剧',	'京剧',	'昆曲',	'梆子',	'庐剧',	'粤剧'					
  ,'打牌',	'扑克牌','跳棋','军棋','围棋',	'象棋','麻将'	,							
  '篮球',	'网球',	'保龄球',	'羽毛球',	'足球',	'桌球',	'高尔夫球',	'排球',	'乒乓球',	'门球'					
  ,'武术',	'太极',	'少林拳',	'八段锦'	,'六字诀',	'气功',	'八极拳',	'咏春拳',	'五禽戏',	'葫芦丝',	'箫',	'螳螂拳',	'养生操',	'晚练',	'晨练'
  ]),
  
  //表单验证
  rules:{
      name:setRules('请输入名称'),
      idCard:[
          { required: true, message: '请输入证件号', trigger: 'blur' },
          {
              pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
              message: '请输入正确的证件号'
          },
      ],
      phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
              pattern: /^1[3456789]\d{9}$/,
              message: '请输入正确的手机号'
          },
      ],
      exerciseType:[],
      cardNumber:[],
      isMarriage:'',
      headImg:setRules('请上传头像'),
      password:setRules('请输入注册密码'),
      interest:'',
      disabilityLevel:setRules('请选择残疾等级'),
      subsidy:setRules('请选择补助类别'),
      children:setRules('请选择子女状况'),
      areaCode:setRules('请选择所属地区'),
      zoneCode:setRules('请选择所属区域'),
      sysNation:setRules('请选择民族'),
      politicsStatus:'',
      education:'',
      censusRegister:'',
      homeAddress:setRules('请选择详细住址'),
      livingStatus:setRules('请选择居住情况'),
      elderlyType:setRules('请选择服务类型'),
      serviceStatus:setRules('请选择服务状态'),
      terminalCode:setRules('请输入终端号码'),
      serviceDemand:setRules('请选择服务需求'),
      urgencyContact:setRules('请输入紧急联系人'),
      address:setRules('请输入详细地址'),
      relation:setRules('请选择与紧急联系人的关系'),
      idCardFront:setRules('请上传身份证正面'),
      idCardContrary:setRules('请上传身份证反面'),
      householdFront:setRules('请上传户口本正面'),
      householdContrary:setRules('请上传户口本老人所在页面'),
      wuBaoHuImg1:setRules('请上传五保证正面'),
      wuBaoHuImg2:setRules('请上传五保证老人所在页面'),
      securityCardFront:setRules('请上传低保证正面'),
      securityCardContrary:setRules('请上传低保证老人所在页面'),
      selfCardAbility:'',
      psychologyStatus:'',
      elderlyClassCode:'',
      bloodType:'',
      disabilityStatus:'',
      irritabilityMedicine:'',
      medicalSecurityStatus:'',
      illness:'',
      isOperation:'',
      operationCause:setRules('请输入手术原因'),
      dietaryHabit:'',
      diet:'',
      smokeStatus:'',
      drinkStatus:'',
      drinkKind:'',
      exerciseStatus:setRules('请选择锻炼频率'),
      exerciseTime:setRules('请选择每次锻炼时间'),
      pocketbook:'',
      monthlyIncome:'',
      monthlyConsumption:'',
      memberLevel:setRules('请输入您的会员等级'),
      socialSecurityCode:setRules('请输入您的社保号'),
      cardInsideCode:'',
      cardCoding:'',
      periodOfValidity:setRules('请选择有效日期'),
      operationTime:setRules('请选择手术日期'),
      urgencyPhone:[
          { required: true, message: '请输入紧急电话', trigger: 'blur' },
          {
              pattern: /^1[3456789]\d{9}$/,
              message: '请输入正确的手机号'
          },
      ],

  }
}
function setRules(ts){
  return [{ required: true, message: ts, trigger: 'blur' },];
}

function slectValue(list){
  var lists=[]
  for(var i in list){
      var list1={}
      list1.value=parseInt(i)+1
      list1.label=list[i]
      lists.push(list1)
  }
  return lists;
}
export default elderly